import { PolicyService } from 'src/app/services/policy/policy.service';
import { Component, Inject, ViewChild } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BilancioService } from 'src/app/services/bilancio/bilancio.service';
import { MaterialitaService } from 'src/app/services/materialita/materialita.service';
import { SintesiService } from 'src/app/services/sintesi/sintesi.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { PianoService } from 'src/app/services/piano/piano.service';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { finalize } from 'rxjs';
import { DoppiaMaterialitaService } from 'src/app/services/doppia-materialita/doppia-materialita.service';
import { ReportVsmeService } from 'src/app/services/report-vsme/report-vsme.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-dialog-invia-mail',
  templateUrl: './dialog-invia-mail.component.html',
  styleUrls: ['./dialog-invia-mail.component.scss'],
  standalone: false,
})
export class DialogInviaMailComponent {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;
  emailFormControl = new FormControl('', [Validators.required, Validators.email]);

  matcher = new MyErrorStateMatcher();

  constructor(
    private readonly utilityService: UtilityService,
    private readonly bilancioService: BilancioService,
    private readonly sintesiService: SintesiService,
    private readonly policyService: PolicyService,
    private readonly pianoService: PianoService,
    private readonly reportVsmeService: ReportVsmeService,
    private readonly materialitaService: MaterialitaService,
    private readonly doppiaMaterialitaService: DoppiaMaterialitaService,

    @Inject(MAT_DIALOG_DATA)
    public data: {
      idModulo: string;
      idSurvey: string;
      tipoModulo:
        | 'MATERIALITA'
        | 'SINTESI'
        | 'BILANCIO'
        | 'POLICY'
        | 'PIANO'
        | 'DOPPIA_MATERIALITA'
        | 'REPORT_VSME'
        | undefined;
      isPermessoSoloRead?: boolean;
      areaDoppiaMaterialita?: 'validatori' | 'stakeholders';
      messaggio: string;
    },
  ) {}
  invia() {
    if (!this.emailFormControl.valid || !this.emailFormControl.value) return;

    const metodoService = this.getMetodoService();

    if (!metodoService) return;

    this.spinnerOver.show();

    metodoService.pipe(finalize(() => this.spinnerOver.hide())).subscribe({
      next: () => {
        this.utilityService.openSnackBar('Mail inviata', '', {
          duration: 2000,
          panelClass: ['success-snackbar'],
        });
      },
      error: () => {
        this.utilityService.openSnackBar('Mail non inviata', '', {
          duration: 2000,
          panelClass: ['red-snackbar'],
        });
      },
    });
  }

  private getMetodoService() {
    if (!this.emailFormControl.valid || !this.emailFormControl.value) return;
    const email = this.emailFormControl.value;
    const { messaggio, tipoModulo, idModulo, areaDoppiaMaterialita } = this.data;

    switch (tipoModulo) {
      case 'MATERIALITA':
        return this.materialitaService.invioTestMail(messaggio, email);

      case 'DOPPIA_MATERIALITA':
        if (areaDoppiaMaterialita === 'validatori') {
          return this.doppiaMaterialitaService.testInvioMailValidazioni(messaggio, email, idModulo);
        } else if (areaDoppiaMaterialita === 'stakeholders') {
          return this.doppiaMaterialitaService.testInvioMail(messaggio, email, idModulo);
        } else {
          console.error('Invio non implementato per areaDoppiaMaterialita:', areaDoppiaMaterialita);
          return null;
        }

      case 'SINTESI':
        return this.sintesiService.invioTestMail(messaggio, email, idModulo);

      case 'BILANCIO':
        return this.bilancioService.invioTestMail(messaggio, email, idModulo);

      case 'POLICY':
        return this.policyService.invioTestMail(messaggio, email, idModulo);

      case 'PIANO':
        return this.pianoService.invioTestMail(messaggio, email, idModulo);

      case 'REPORT_VSME':
        return this.reportVsmeService.invioTestMail(messaggio, email, idModulo);

      default:
        console.error('Tipo modulo non riconosciuto:', tipoModulo);
        return null;
    }
  }
}
